import React, { Component } from 'react';
import ScrollFadeIn from "./../../components/scrollFadeIn";
import {Helmet} from "react-helmet";

export default class BlogDetail extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>{'Kat Medina Blog | Articles | Observations'}</title>
          <meta name="description" content="Stepping Outside of Anger's Fire article by Kat Medina, author of the book, The Joys of Jet Lag. How to use anger as a tool instead of a destructive emotion. Mindfulness techniques for managing anger." />
        </Helmet>
        <ScrollFadeIn>
          <p className="tiny-padding">{'The other day I realized something interesting. Stress shows up for me wearing two different masks: anger and overwhelm. It’s subtle at first, almost unnoticeable. Hints of overwhelm appear as tasks begin to stack higher on an already full plate. I brush away the thought of stress, refusing to acknowledge its presence. A mantra of “I got this, I can do it all” loops in the back of my mind with every shallow breath I take.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'More emails, more requests, more demands on my time, and as the reality of a buried schedule sets in, the sense of overwhelm begins to transform into a feeling of anger that I’m not incredibly proud of. When the transition happens, I know that stress has somehow managed to discretely shove a stick up my ass to use me as its frantic puppet.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'It starts innocently enough. A furrowed brow creates a facial buttcrack between my eyes. I unwittingly clench my jaw regardless of my nightly mouth guard efforts. I adopt a spidey sense of frustration that provides me with a razor-sharp focus for all that is falling short of my expectations.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'And then, I lash out at everything and everyone.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Nobody is spared from the wrath of stressful anger once it takes over. Overwhelm is the passive response to stress that creates a feeling of victimhood and weakness. Anger feels easier and better because it lets me place blame wherever I see fit.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'The problem is that when anger takes the wheel, I can’t think clearly and tend to see life through a distorted lens of pissed-off-ness. It’s as though my anger is a fire and when I’m tits-deep in it, I’m fully consumed by the flames. A reasonable point of view is not an option when I am burning alive.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'The solution is to step outside of the fire–only then can I appreciate and enjoy its heat. Because anger is actually a valuable emotion when used properly.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'When we harness anger and learn how to control the flames, it can become an incredible tool for taking action and implementing change. The key is to feel the emotion fully, without stifling it or becoming consumed by it. If we stifle an emotion it just comes back stronger the next time. Instead, if we give ourselves the gift of experiencing emotion with curiosity and kindness, it will pass without ever even singeing our skin.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'The trick to getting out of the fire is to observe the physical sensations of anger and label them as they happen. The act of identifying what you are feeling, both physically and emotionally, creates space for you to recognize that you are not the emotion, rather you are feeling the emotion.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'“I am angry” vs. “I feel angry” are two very different statements. By identifying the emotion as something you are feeling, you are subconsciously disconnecting yourself from its gnarly grip and allowing room for clarity and compassion to step in. When that space is created, the next step is very simple–swap your expectations for appreciation.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Anger and gratitude cannot exist simultaneously. When you detach yourself from the emotion, you give yourself the opportunity to choose to either focus on what is going right or what is going wrong (spoiler alert- both are always available). It’s from that place that you can regain a big picture perspective for effective decision-making to combat stress and see things as they really are–opportunities to learn, grow, and discover the hidden gifts that are always available.'}
          </p>
        </ScrollFadeIn>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/blogDetail/anger.js